import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'orders': [],
};

export const kanbanLogistics = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_KANBAN_ORDERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_KANBAN_ORDERS]: (state, action) => ({
      ...state,
      'loading': false,
      'orders': action.response.data,
    }),
    [ActionTypes.FETCHED_KANBAN_ORDERS_FAILED]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};


const INITIAL_STATE_DETAIL = {
  'loading': false,
  'detail': {
    'orderInfo': {},
    'tasks': [],
    'parts': [],
    'comments': [],
    'subtasks': [],
  },
};

export const kanbanLogisticsDetail = (state, action) => {
  return createReducer(INITIAL_STATE_DETAIL, {
    [ActionTypes.FETCHING_KANBAN_ORDER_DETAIL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_KANBAN_ORDER_DETAIL]: (state, action) => ({
      ...state,
      'loading': false,
      'detail': action.response.data,
    }),
    [ActionTypes.FETCHED_KANBAN_ORDER_DETAIL_FAILED]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_DETAIL,
    }),
  })(state, action);
};
